import { Component, HostListener, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { first } from 'rxjs/operators';

type ISODate = string | null;

interface RawAction {
  Action: string;
  LevelID: string;
  ProgramID: string;
  ProgramID1: string;
  ComponentName: string;
  TragetDays: number | string;
  AssignDate: ISODate;
  PendingCompletedDays: string;
  UserID: string;
  AppID: string;
  Status: string;
  Remarks: string;
  ActiveStatus: number;
  ActionDate: ISODate;
  UpdateDate: ISODate;
  NextUser: string;
}

interface ActionItem {
  name: string;
  status: string;
  raw: RawAction;
}

interface AppMeta {
  AppID: string;
  Applicant?: string;
  TotalActions: number;
  LatestAction?: string;
  LatestStatus?: string;
  NextUser?: string;
  Remarks?: string;
  Component?: string;
}

interface Application {
  id: string;
  name: string;
  actions: ActionItem[];
  meta: AppMeta;
}

const STATUS_ICON: Record<string, string> = {
  A: 'assets/emojis/approved.png',
  P: 'assets/emojis/pending.png',
  R: 'assets/emojis/rejected.png',
  MR: 'assets/emojis/more-info.png',
  RP: 'assets/emojis/reply-pending.png',
  H: 'assets/emojis/hold.png',
  I: 'assets/emojis/in-progress.png',
  C: 'assets/emojis/completed.png',
  N: 'assets/emojis/unknown.png',
};

@Component({
  selector: 'app-application-work-flow-diag',
  templateUrl: './application-work-flow-diag.component.html',
  styleUrls: ['./application-work-flow-diag.component.scss']
})
export class ApplicationWorkFlowDiagComponent implements OnInit, OnChanges {
  @Input() applicationId!: string;
  @Input() showLegend: boolean = false;

  // --- Original properties for "all" data ---
  applications: ReadonlyArray<Application> = [];
  selectedApplication: Application | null = null;
  currentStepIndex = 0;

  // --- New properties to store split data ---
  pondApplications: ReadonlyArray<Application> = [];
  miApplications: ReadonlyArray<Application> = []; 
  
  // --- New state for "pond" stepper ---
  pondSelectedApplication: Application | null = null;
  pondCurrentStepIndex = 0;

  // --- New state for "mi" stepper ---
  miSelectedApplication: Application | null = null; 
  miCurrentStepIndex = 0; 


  cols = 8;


  displayDialog: boolean = false;

  currentActionData: RawAction | null = null;
  currentActionName: string = '';

  // --- Default Flow Dialog State ---
  displayDefaultDialog: boolean = false;
  defaultFlowTitle: string = '';
  defaultStepRows: any[][] = [];
  defaultStepsTotalCount: number = 0;

  // --- Manual Default Steps Lists ---
  readonly miManualSteps = [
    "Application Submission",
    "Application documents scrutiny and recommendation",
    "Application Verification",//  Step not included in history
    "Application Approval",
    "MI Pre Survey", // step not included in history
    "Vendor Estimation",
    "Estimation,design,documents scrutiny and recommendation",
    "Estimation approval",
    "Estimate Verification",// step not included in history 
    "Challan generation & Payments/intimation",
    "Payment Intimation",
    "MIS installation and BOQ Submission",
    // "Processing of Farmer Share to Vendor",// NO DEFAULT PLACE
    "MIS Field Physical Verification",
    "MI Feild Survey Verification",// step not included in history
    "MIS Field Physical Re-Verification(5%) and recommendation",
    "PV scrutiny,MIS Subsidy checking and recommendation",
    "MI Subsidy recommendation(DDMI)",//same name different level
    "MI Subsidy recommendation(DMICADA)",//same name different level
    "MI Subsidy approval",
    "Lot generation for subsidy disbursement"
  ];

  readonly pondManualSteps = [
    "Application Submission",
    "Application documents scrutiny and recommendation",
    "Application Verification",
    "Application Approval",
    "Farmer Pond Stage1 Intimation",
    "Pond Stage1 Verification (JE)",//same name different level
    "Pond Stage1 Verification(SDO)",//same name different level
    "Pond Stage1 Verification(XEN)",//same name different level
    "Pond Stage1 Subsidy Calculation(JE-EW)",//same name different level
    "Pond Stage1 Subsidy Calculation(DDTANK)",//same name different level
    "Pond Stage1 Subsidy Calculation(DD-EW)",//same name different level
    "Pond Stage1 Subsidy Calculation(ADMIN)",//same name different level
    "Lot generation for subsidy disbursement(Pond1)",
    "Farmer Pond Stage2 Intimation",
    "Pond Stage2 Verification(JE)",//same name different level
    "Pond Stage2 Verification(SDO)",//same name different level
    "Pond Stage2 Verification(XEN)",//same name different level
    "Pond Stage2 Subsidy Calculation(JE-EW)",// same name different level
    "Pond Stage2 Subsidy Calculation(DDTANK)",//same name different level
    "Pond Stage2 Subsidy Calculation(DD-EW)",//same name different level
    "Pond Stage2 Subsidy Calculation(ADMIN)",//same name different level
    "Lot generation for subsidy disbursement(Pond2)",
    "Pond Stage3 Subsidy Calculation(JE-EW)",//same name different level
    "Pond Stage3 Subsidy Calculation(DDTANK)",//same name different level
    "Pond Stage3 Subsidy Calculation(DD-EW)",//same name different level
    "Pond Stage3 Subsidy Calculation(ADMIN)",//same name different level
    "Lot generation for subsidy disbursement(Pond3)"
  ];

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService
  ) {}

  ngOnInit(): void {
    this.updateCols();
    this.selectedApplication = null;
    this.applications = [];
    this.pondApplications = [];
    this.miApplications = [];
    
    // --- Reset new state ---
    this.pondSelectedApplication = null;
    this.miSelectedApplication = null; 
    this.pondCurrentStepIndex = 0;
    this.miCurrentStepIndex = 0; 
    // ---
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['applicationId'] && this.applicationId) {
      this.fetchApplicationData(this.applicationId);
      this.selectedApplication = null;
      this.applications = [];
      this.pondApplications = [];
      this.miApplications = []; 

      // --- Reset new state on change ---
      this.pondSelectedApplication = null;
      this.miSelectedApplication = null; 
      this.pondCurrentStepIndex = 0;
      this.miCurrentStepIndex = 0; 
      // ---
    }
  }
openDefaultFlowDialog(type: 'MI' | 'Pond') {
    this.defaultFlowTitle = type === 'MI' ? 'MI Default Workflow' : 'Pond Default Workflow';
    const sourceList = type === 'MI' ? this.miManualSteps : this.pondManualSteps;
    const currentApp = type === 'MI' ? this.miSelectedApplication : this.pondSelectedApplication;

    const rawHistory = currentApp?.actions || [];
    const approvedHistory = rawHistory.filter(action => action.status === 'A');

    // 1. HELPER: Find History (Split Logic: Safe for Old & New)
   
    const mapStepToHistory = (stepName: string, listIndex: number) => {
      const stepNameNormal = stepName.trim().toLowerCase();
      let foundItem = null;

      // 1. Basic Name Match
      let potentialHistoryItems = approvedHistory.filter(h => 
          stepNameNormal.includes(h.name.trim().toLowerCase())
      );

      // 2. CONDITIONAL BRACKET CHECK
      if (potentialHistoryItems.length > 0 && stepNameNormal.includes('(')) {
        
        // find if it's a program check (pond1/2/3) or level check (others)
        const isProgramCheck = stepNameNormal.includes('pond1') || stepNameNormal.includes('pond2') || stepNameNormal.includes('pond3');

        if (isProgramCheck) {
            //  Lot Generation (Program ID Only) ===
            const strictFiltered = potentialHistoryItems.filter(h => {
                const pId = (h.raw?.ProgramID1 || h.raw?.ProgramID || '').toLowerCase().trim();
                return pId && stepNameNormal.includes(pId);
            });
            
            // if match found, use it; else return null (Pond strict)
            if (strictFiltered.length > 0) {
                potentialHistoryItems = strictFiltered;
            } else {
                return null; // if no match, return null directly
            }
        } 
        else {
            //  Verification/Subsidy (Level ID Only) 
            const strictFiltered = potentialHistoryItems.filter(h => {
                const lId = (h.raw?.LevelID || '').toLowerCase().trim();
                return lId && stepNameNormal.includes(lId);
            });

            // if match found, use it
            if (strictFiltered.length > 0) {
                potentialHistoryItems = strictFiltered;
            }
        }
      }

      // 3. Pick Latest
      if (potentialHistoryItems.length > 0) {
        potentialHistoryItems.sort((a, b) => new Date(b.raw?.ActionDate || 0).getTime() - new Date(a.raw?.ActionDate || 0).getTime());
        foundItem = potentialHistoryItems[0];
      }

      return foundItem;
    };

    let finalOrderedSteps = [];

    // 2. LOGIC FOR POND (Strict Block Moving) - SAME AS BEFORE
   
    if (type === 'Pond') {
      const allMappedSteps = sourceList.map((step, index) => ({
        originalStep: step,
        history: mapStepToHistory(step, index),
        originalIndex: index
      }));

      const headSteps = allMappedSteps.slice(0, 4);
      const stage1Block = allMappedSteps.slice(4, 13);
      const stage2Block = allMappedSteps.slice(13, 22);
      const tailSteps = allMappedSteps.slice(22);

      // check active stages(ignore lot generation)
      const isStage1Active = stage1Block.filter(s => !s.originalStep.toLowerCase().includes('lot generation')).some(s => s.history !== null);
      const isStage2Active = stage2Block.filter(s => !s.originalStep.toLowerCase().includes('lot generation')).some(s => s.history !== null);

      let middleSteps = [];

      if (isStage2Active && !isStage1Active) {
          middleSteps = [...stage2Block, ...stage1Block];
      } else {
          middleSteps = [...stage1Block, ...stage2Block];
      }

      finalOrderedSteps = [...headSteps, ...middleSteps, ...tailSteps];

    } else {
      // MI Logic
      finalOrderedSteps = sourceList.map((step, index) => ({
        originalStep: step,
        history: mapStepToHistory(step, index),
        originalIndex: index
      }));
    }

    // 3. FINAL STATUS (User Logic) - SAME AS BEFORE
  
    
    let lastApprovedIndex = -1;
    finalOrderedSteps.forEach((item, idx) => {
        if (item.history && item.history.status === 'A') {
            lastApprovedIndex = idx;
        }
    });

    const formattedSteps = finalOrderedSteps.map((item, index) => {
      let status = 'N';
      let rawData = item.history?.raw || null;
      let customText = '';

      if (item.history) {
        status = item.history.status;
      } else {
        const isMI = type === 'MI';
        const isPondHead = type === 'Pond' && index < 4;
        
        if ((isMI || isPondHead) && index < lastApprovedIndex) {
            status = 'A';
            customText = 'Completed (Auto)';
            rawData = null;
        } 
        else if (type === 'Pond') {
             const nameLower = item.originalStep.toLowerCase();
             let isStrictlyCompleted = false;

             if (nameLower.includes('verification(sdo)')) {
                 const xenName = item.originalStep.replace('(SDO)', '(XEN)');
                 const isXenApproved = approvedHistory.some(h => h.name === xenName);
                 if (isXenApproved) isStrictlyCompleted = true;
             }

             if (nameLower.includes('subsidy calculation(ddtank)')) {
                 const ddEwName = item.originalStep.replace('(DDTANK)', '(DD-EW)');
                 const isDdEwApproved = approvedHistory.some(h => h.name === ddEwName);
                 if (isDdEwApproved) isStrictlyCompleted = true;
             }

             if (isStrictlyCompleted) {
                 status = 'A';
                 customText = 'Completed (Auto)';
                 rawData = null;
             } else if (index === lastApprovedIndex + 1) {
                 status = 'N'; 
                 customText = 'Pending';
             } else {
                 status = 'N'; 
                 customText = '(Not reached)';
             }
        }
        else if (index === lastApprovedIndex + 1) {
            status = 'N'; 
            customText = 'Pending';
        } else {
            status = 'N';
            customText = '(Not reached)';
        }
      }

      return { 
        name: item.originalStep, 
        status: status, 
        raw: rawData, 
        customText: customText 
      };
    });

    this.defaultStepsTotalCount = formattedSteps.length;
    this.defaultStepRows = this.chunkArray(formattedSteps, this.cols);
    this.displayDefaultDialog = true;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateCols();
  }

  private updateCols(): void {
    const w = window.innerWidth;
    if (w <= 640) this.cols = 3;
    else if (w <= 1024) this.cols = 4;
    else this.cols = 8;
  }

 private fetchApplicationData(appId: string): void {
  this.loader.start();

  this.deptDashBoardService.workFlowAllStatus(appId)
    .pipe(first())
    .subscribe({
      next: (res: any) => {

        this.loader.close();

        if (res && res.length > 0) {

          const apiData: RawAction[] = res.map((item: any) => ({
            Action: item.Action || item.ProgramIDZ || item.ComponentName || 'Action',
            LevelID: item.LevelID,
            ProgramID: item.ProgramID,
            ProgramID1: item.ProgramID1,
            ComponentName: item.ComponentName,
            TragetDays: item.TragetDays,
            AssignDate: item.AssignDate,
            PendingCompletedDays: item.PendingCompletedDays,
            UserID: item.UserID,
            AppID: item.AppID,
            Status: item.Status?.toUpperCase() || 'N',
            Remarks: item.Remarks,
            ActiveStatus: item.ActiveStatus,
            ActionDate: item.ActionDate,
            UpdateDate: item.UpdateDate,
            NextUser: item.NextUser,
          }));

          // Split Arrays
          const pondData: RawAction[] = [];
          const otherData: RawAction[] = [];
          const scrutinyAction = 'application documents scrutiny and recommendation';

          for (const item of apiData) {

            const action = item.Action?.trim().toLowerCase();
            const nextUser = item.NextUser?.trim().toLowerCase();
            const programId1 = item.ProgramID1?.trim().toLowerCase();

            // --- 1. PRIORITY CHECK: SCRUTINY ---
            // for scrutiny, check programId1 for pond/mi
            if (action === scrutinyAction) {
              const isPond = programId1?.includes('pond');
              const isMi = programId1?.includes('mi');

              if (isPond) {
                pondData.push(item);
              }
              
              // Logic: if mi or not pond, go to miData
              if (isMi || !isPond) {
                otherData.push(item);
              }

              continue; // *** IMPORTANT: This will skip the code below ***
            }

            // --- 2. CHECK: APPLICATION SUBMISSION ---
            if (action === 'application submission') {
              if (nextUser?.startsWith('je')) {
                pondData.push(item);
              } else {
                otherData.push(item);
              }
              continue; // Next item
            }

            // --- 3. CHECK: GENERAL ITEMS () ---
            if (programId1?.startsWith('pond')) {
              pondData.push(item);
            } else {
              otherData.push(item);
            }
          }

          // Build Final Lists
          this.pondApplications = this.buildApplicationsFromSample(pondData);
          this.miApplications = this.buildApplicationsFromSample(otherData);

          // // Console Log
          // console.log("Pond Applications :", this.pondApplications);
          // console.log("MI Applications :", this.miApplications);

          // Defaults
          this.pondSelectedApplication = this.pondApplications[0] ?? null;
          this.miSelectedApplication = this.miApplications[0] ?? null;

          this.pondCurrentStepIndex = 0;
          this.miCurrentStepIndex = 0;
        }
      },

      error: (err) => {
        this.loader.close();
        console.error('API error', err);
      }
    });
}


  range(n: number): number[] {
    return Array.from({ length: Math.max(0, n) }, (_, i) => i);
  }

  private buildApplicationsFromSample(rows: RawAction[]): Application[] {
    const byApp = new Map<string, RawAction[]>();
    for (const r of rows) {
      const key = r.AppID || 'UNKNOWN';
      if (!byApp.has(key)) byApp.set(key, []);
      byApp.get(key)!.push(r);
    }

    const apps: Application[] = [];
    for (const [appId, items] of byApp.entries()) {
      items.sort((a, b) => {
        const da = Date.parse(a.ActionDate || a.AssignDate || '') || 0;
        const db = Date.parse(b.ActionDate || b.AssignDate || '') || 0;
        return da - db;
      });

      const actions: ActionItem[] = items.map(r => ({
        name: (r.Action || r.ProgramID || r.ComponentName || 'Action').trim(),
        status: String(r.Status || 'N').toUpperCase(),
        raw: r
      }));

      const first = items[0];
      const last = items[items.length - 1];
      const meta: AppMeta = {
        AppID: appId,
        Applicant: last?.UserID || first?.UserID,
        TotalActions: actions.length,
        LatestAction: last?.Action,
        LatestStatus: last?.Status,
        NextUser: last?.NextUser,
        Remarks: last?.Remarks,
        Component: last?.ComponentName || first?.ComponentName || '',
      };

      apps.push({ id: appId, name: appId, actions, meta });
    }
    return apps;
  }

  getStatusIconUrl(code: string | null | undefined): string {
    return STATUS_ICON[String(code || 'N').toUpperCase()] ?? STATUS_ICON['N'];
  }

  getStatusText(code: string | null | undefined): string {
    switch (String(code || 'N').toUpperCase()) {
      case 'A': return 'approved';
      case 'C': return 'completed';
      case 'P': return 'pending';
      case 'R': return 'rejected';
      case 'H': return 'on hold';
      case 'I': return 'in progress';
      case 'MR': return 'data required';
      case 'RP': return 'reply pending';
      default: return 'unknown';
    }
  }

  getActionDate(a: RawAction): string {
    return a?.ActionDate ?? a?.AssignDate ?? '-';
  }

 
  get stepRows(): ActionItem[][] {
    const actions = this.selectedApplication?.actions ?? [];
    return this.chunkArray(actions, this.cols);  
  }

  get pondStepRows(): ActionItem[][] {
    const actions = this.pondSelectedApplication?.actions ?? [];
    return this.chunkArray(actions, this.cols);
  }


  get miStepRows(): ActionItem[][] { 
    const actions = this.miSelectedApplication?.actions ?? []; 
    return this.chunkArray(actions, this.cols);
  }


  private chunkArray<T>(arr: ReadonlyArray<T>, size: number): T[][] {
    if (!arr?.length || size <= 0) return [];
    const out: T[][] = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size) as T[]);
    return out;
  }

  
  get currentStepLabel(): string | null {
    const actions = this.selectedApplication?.actions ?? [];
    return actions[this.currentStepIndex]?.name ?? null;
  }

 
  get pondCurrentStepLabel(): string | null {
    const actions = this.pondSelectedApplication?.actions ?? [];
    return actions[this.pondCurrentStepIndex]?.name ?? null;
  }

 
  get miCurrentStepLabel(): string | null { 
    const actions = this.miSelectedApplication?.actions ?? []; 
    return actions[this.miCurrentStepIndex]?.name ?? null; 
  }


  goToStep(globalIndex: number): void {
    const actions = this.selectedApplication?.actions ?? [];
    if (!actions.length || globalIndex < 0 || globalIndex >= actions.length) return;

    this.currentStepIndex = globalIndex;
    const action = actions[globalIndex]?.raw;
    this.currentActionData = action;
    this.currentActionName = action?.Action ?? 'Unknown Action';
    this.displayDialog = true;
  }

 
  goToPondStep(globalIndex: number): void {
    const actions = this.pondSelectedApplication?.actions ?? [];
    if (!actions.length || globalIndex < 0 || globalIndex >= actions.length) return;

    this.pondCurrentStepIndex = globalIndex; 
    const action = actions[globalIndex]?.raw;
    this.currentActionData = action; 
    this.currentActionName = action?.Action ?? 'Unknown Action'; 
    this.displayDialog = true; 
  }

 
  goToMiStep(globalIndex: number): void { 
    const actions = this.miSelectedApplication?.actions ?? []; 
    if (!actions.length || globalIndex < 0 || globalIndex >= actions.length) return;

    this.miCurrentStepIndex = globalIndex; 
    const action = actions[globalIndex]?.raw;
    this.currentActionData = action; 
    this.currentActionName = action?.Action ?? 'Unknown Action'; 
    this.displayDialog = true; 
  }


  rowIndex(i: number): number { return Math.floor(i / this.cols); }
  isLastInRow(i: number, total: number): boolean {
    return ((i % this.cols) === this.cols - 1) || (i === total - 1);
  }
  hasNext(i: number, total: number): boolean { return i < total - 1; }
  isRTLRow(rowIdx: number): boolean { return (rowIdx % 2) === 1; }
  showStraight(i: number, total: number): boolean {
    return this.hasNext(i, total) && ((i % this.cols) !== this.cols - 1);
  }
  showBend(i: number, total: number): boolean {
    return this.hasNext(i, total) && this.isLastInRow(i, total);
  }

  statusClass(code: string | null | undefined): string {
    const c = String(code || 'N').toUpperCase();
    return {
      'A': 'status-a',
      'C': 'status-c',
      'P': 'status-p',
      'R': 'status-r',
      'H': 'status-h',
      'I': 'status-i',
      'MR': 'status-mr',
      'RP': 'status-rp',
    }[c] ?? 'status-n';
  }

  trackByApp = (_: number, app: Application) => app.id;
  trackByIndex = (i: number) => i;
}

